document.addEventListener("DOMContentLoaded", () => {
  const accordionButtons = document.querySelectorAll(".accordion-button");

  accordionButtons.forEach(button => {
    button.addEventListener("click", () => {
      const parentItem = button.parentElement; // Das aktuelle Akkordeon-Item
      const content = parentItem.querySelector(".accordion-content");

      // Toggle: Schließen aller anderen Akkordeons
      document.querySelectorAll(".accordion-item").forEach(item => {
        if (item !== parentItem) {
          item.classList.remove("open");
          item.querySelector(".accordion-content").style.display = "none";
        }
      });

      // Toggle: Aktuelles Akkordeon öffnen/schließen
      if (parentItem.classList.contains("open")) {
        parentItem.classList.remove("open");
        content.style.display = "none";
      } else {
        parentItem.classList.add("open");
        content.style.display = "block";
      }
    });
  });
});
